import {Component, computed, effect, inject, input, InputSignal} from '@angular/core';
import {SectionsContainer} from "../../core/definitions/sections-container";
import {ObjectCopySection} from "../object-copy-section/object-copy-section";
import {ObjectCopyFieldSelectorComponent} from "../object-copy-field-selector/object-copy-field-selector.component";
import {SharedModule} from "../../shared/shared.module";
import {ObjectCopyService} from "../object-copy.service";
import {MetaField} from "../../core/definitions/meta-field";
import {EditFieldContextComponent} from "../../shared/edit-field-context/edit-field-context.component";

@Component({
  selector: 'app-section-view-copy',
  imports: [
    ObjectCopySection,
    ObjectCopyFieldSelectorComponent,
    SharedModule,
    EditFieldContextComponent,
  ],
  templateUrl: './section-view-copy.html',
  styleUrl: './section-view-copy.scss'
})
export class SectionViewCopy {
  readonly objectCopyService = inject(ObjectCopyService);

  sectionsContainer: InputSignal<SectionsContainer> = input();
  sourceArtifactId: InputSignal<string> = input();
  isFieldRequiredFn: InputSignal<(field: MetaField) => boolean> = input();

  constructor() {
    effect(async () => {
      this.objectCopyService.initializeCopyData(
        this.sectionsContainer(),
        this.sourceArtifactId(),
        this.isFieldRequiredFn()
      );
    });
  }

  sections = computed(() => this.objectCopyService.copyableSections());
}
